import {LayoutAbbreviation, LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    Background: {
      ShowerWall: 50100,
      CenterWall: 50300,
      BackWall: 50600,
      Floor: 50700,
      BackgroundBG: 50800,
    },
    ShowerWallAccent: 1000,
    Window: {
      WindowBody: 45000,
      WindowKits: 1100
    },
    Accessories: {
      LargeCornerCaddie: 2010,
      LargeCornerCaddie2: 2020,
      Fixture: 2100,
      LargeCornerSeat: 2310,
      LargeCornerSeat2: 2320,
      CornerCaddie: 2410,
      CornerCaddie2: 2420,
      SoapDish: 2500,
      SoapDish2: 2510,
      SmallCornerShelf: 2600,
      GrabBar: 2700,
      GrabBar2: 2710,
      CornerShelf1: 2810,
      CornerShelf2: 2820,
      CornerShelf3: 2830,
      CornerShelf4: 2840,
      CornerShelf5: 2850,
      CornerShelf6: 2860,
      ShowerPod: 2900,
      Seats: 2950,
      ShowerRod: 4200,
    },
    Shower: {
      ShowerPan: 3200,
      ShowerFixture: 3410,
      ShowerFixture2: 3420,
      ShowerDoorHandle: 3600,
      // Threshold
      TubCombo: {
        WallConfiguration: 3600,
        Liner: 3700,
        WalkInTub: 3900,
        JettedTub: 4000,
      },
    },
    Walls: {
      LeftWall: 40120,
    },
    Globals: {
      ToiletPaper: 8000,
      ToiletPaperHolder: 8050,
      Towel: 8100,
      LightFixture: 8200,
      LampFixture: 8250,
      DecorWindow: 8300,
      DecorSeat: 8400,
    },
    Bathtub: {
      BathTubFixture: 9000,
      BathTubBody: 9100,
    },
    decor: 11111,
    skirting_board: 2500,
    shower_curb: 3000,
    bathtub_body: 5304,
    bathtub_fixture: 5300,
    window: 45000,
    vanity_cabinet: 6100,
    vanity_countertop: 6000,
    shower_arm: 7315,
    shower_head_bundle: 7456,
    shampoo_shelf: 7555,
    split_wall: 7000,
    towel_bar: 2617,
    towel_ring: 2615,
    shower_glass: 3549,
    grab_bar: 2700,
    robe_hook: 5059,
    vanity_handle: 5200,
    vanity_backsplash: 5500,
    vanity_mirror: 5600,
    vanity_faucet: 5700,
    vanity_sink: 5800,
    shower_pan_combo: 6743,
    window_body: 7301,
    toilet_brush: 9816,
    toilet: 9960,
    paper_holder: 10004,
    shower_wall: 40020,
    left_wall_splitter: 40000,
    left_wall_crop: 40150,
    right_wall_crop: 48030,
    front_wall_crop: 49075,
    walls_ceiling: 50900,
    shower_wall_mirror: 50050,
    back_wall: 50100,
    front_wall: 50200,
    left_wall: 50500,
    right_wall: 54000,
  };
});


const getLayerDimensions = (layer, currentLayout, canvasDimensions) => {
  const fullImagesFactor = UseFullSizeImages ? 177.77 : 100;
  const sizeFactor = fullImagesFactor / 100;

  if (layer.coords) {
    const COORDS_MAX = 1;

    const x1Percentage = (layer.coords.min_x * 100) / COORDS_MAX;
    const x2Percentage = (layer.coords.max_x * 100) / COORDS_MAX;
    const y1Percentage = (layer.coords.min_y * 100) / COORDS_MAX;
    const y2Percentage = (layer.coords.max_y * 100) / COORDS_MAX;
    let x1 = sizeFactor*((canvasDimensions.width * x1Percentage) / 100);
    let x2 = sizeFactor*((canvasDimensions.width * x2Percentage) / 100);
    let y1 = sizeFactor*((canvasDimensions.height * y1Percentage) / 100);
    let y2 = sizeFactor*((canvasDimensions.height * y2Percentage) / 100);

    return {
      polygonArray: [[x1, y1], [x2, y1], [x2, y2], [x1, y2]],
      width: (x2 - x1),
      height:(y2 - y1)
    };
  }

  // console.log("layer without coords", layer);

  const {zIndex} = layer;
  switch (zIndex) {
    // case layouts[currentLayout].Background.ShowerWall:
    //   return {
    //     polygonArray: [[sizeFactor*350,sizeFactor*50],[sizeFactor*950,sizeFactor*50],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
    //     width: sizeFactor*600,
    //     height: sizeFactor*900
    //   };
    case layouts[currentLayout].Walls.CenterWall:
    case layouts[currentLayout].Background.CenterWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return null;
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*360,0],[sizeFactor*760,0],[sizeFactor*760,sizeFactor*880],[sizeFactor*360,sizeFactor*880]],
            width: sizeFactor*400,
            height: sizeFactor*880
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Walls.RightWall:
    case layouts[currentLayout].Background.RightWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*750,0],[sizeFactor*1920,0],[sizeFactor*1920,sizeFactor*1080],[sizeFactor*750,sizeFactor*1080]],
            width: sizeFactor*1170,
            height: sizeFactor*1080
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*120,0],[sizeFactor*1920,0],[sizeFactor*1920,sizeFactor*930],[sizeFactor*120,sizeFactor*930]],
            width: sizeFactor*1900,
            height: sizeFactor*930
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Walls.LeftWall:
    case layouts[currentLayout].Background.LeftWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[0,0],[sizeFactor*600,0],[sizeFactor*600,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*600,
            height: sizeFactor*1080
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[0,0],[sizeFactor*600,0],[sizeFactor*600,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*600,
            height: sizeFactor*1080
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Background.Floor: {
      switch (currentLayout) {
        default: {
        // case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[0,sizeFactor*600],[sizeFactor*1920,sizeFactor*600],[sizeFactor*1920,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*1920,
            height: sizeFactor*480
          };
        }
      }
    }
    case layouts[currentLayout].Background.ShowerWall:
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,0],[sizeFactor*1650,0],[sizeFactor*1650,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*1300,
            height: sizeFactor*930
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*250,0],[sizeFactor*1250,0],[sizeFactor*1250,sizeFactor*930],[sizeFactor*250,sizeFactor*930]],
            width: sizeFactor*1000,
            height: sizeFactor*930
          };
        }
      }
      return null;
    default:
      return null
  }
};

export default {
  layouts,
  getLayerDimensions
}


